export const PROVISIONED_USER_GROUPS = [
  'None',
  'Administrators',
  'Operators',
  'Viewers',
  'Custom',
] as const;

export type ProvisionedUserGroup = (typeof PROVISIONED_USER_GROUPS)[number];

export interface ProvisionedUser {
  id: string;
  firstName: string;
  lastName: string;
  displayName: string;
  email: string;
  userGroup: ProvisionedUserGroup;
  employmentNumber?: string;
  createdAt: string;
  createdByEmail: string;
  status: 'active';
}

export function isProvisionedUserGroup(value: string): value is ProvisionedUserGroup {
  return (PROVISIONED_USER_GROUPS as readonly string[]).includes(value);
}
